export default "__VITE_ASSET__CmYX_hWi__"